/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Navigation/NavBack.ts" />
namespace HA.Core.Controller.Navigation {
    import NavBackItem = HA.Core.HTML.Navigation.NavBack;

    export class NavBack extends NavigationItem {
        protected createTag(data: any) {
            this.addToData("tag", new NavBackItem(data));
        }
    }
}
